import React, { FC } from "react";
import { SvgIconProps } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";

export const UnlockIcon: FC<SvgIconProps> = (props) => {
  return (
    <LockOpenIcon sx={{ fontSize: 14, color: "primary.main" }} {...props} />
  );
};
